import { render, staticRenderFns } from "./componentes.vue?vue&type=template&id=13981e5c"
import script from "./componentes.vue?vue&type=script&lang=js"
export * from "./componentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports